export default __webpack_public_path__ + "static/attribute2-862c4b0a920cf986d82abb27e67ef70a.png";